var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhrase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,252.59V3.58H34.77v249Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.82,252.59,110.93,55h-1.26q.63,11.4,1.11,20.95t.71,17.11q.23,7.59.23,13V252.59H79V3.58h48.36l49,188.72h.94l49-188.72H274.8v249H241.3V106.28q0-6.12.16-13.71T242,75.71q.41-9.28.87-20.52h-1.26l-50.88,197.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M416.4,252.59l-14.7-70H348.6l-14.85,70H296.61l55.94-249h43.93l56.89,249ZM396,149.38,380.84,74.09q-1.27-7.16-2.37-14.05t-2-13.46q-.87-6.55-1.81-12.34-.48,5.61-1.35,12.09T371.28,59.7q-1.18,6.9-2.45,13.88L354,149.38Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M551.51,117.18h65.26V243.06a159.22,159.22,0,0,1-31.29,9.7A166.32,166.32,0,0,1,552.61,256q-28.44,0-47.09-16.27t-28-45.13q-9.33-28.87-9.32-67,0-38.31,10.35-67t30.58-44.62Q529.38,0,559.25,0a101.8,101.8,0,0,1,29.39,4.17,98.71,98.71,0,0,1,25.44,11.67L602.86,47A86.28,86.28,0,0,0,582,36.45a67.26,67.26,0,0,0-21.64-3.58q-18.35,0-30.82,11.07t-18.8,32.37q-6.33,21.28-6.33,52.12,0,27.76,5.3,49.13T526.22,211q11.22,12,28.92,12a88.2,88.2,0,0,0,14.7-1.2,71.72,71.72,0,0,0,13.11-3.4V149.72H551.51Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M656.12,252.59V3.58h34.76v249Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M882.41,252.59H841L766.89,62.68h-1.26q.79,10.56,1.26,20.18t.64,18q.15,8.36.31,15.5V252.59H735.13V3.58h41.09l74.11,186.33h1.11q-.48-10.89-1-20.44t-.71-17.71q-.24-8.17-.24-15V3.58h32.87Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1024,252.59H926.66V3.58H1024V35.94H961.42v70.68h58.63v32.54H961.42v80.39H1024Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.94,704,50.48,399.32h-2q1,17.6,1.75,32.31T51.35,458q.38,11.7.37,20.1V704H0V320H76.46l77.46,291h1.5l77.47-291H309.6V704h-53V478.38q0-9.45.25-21.14t.88-26q.62-14.31,1.37-31.65h-2L176.66,704Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M533.49,704l-23.24-108h-84L402.8,704H344.08l88.46-384H502l90,384ZM501.26,544.83l-24-116.09q-2-11-3.75-21.67t-3.12-20.75q-1.38-10.11-2.88-19-.75,8.67-2.12,18.65t-3.25,20.61q-1.87,10.65-3.87,21.41L434.79,544.83Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M837.84,704H776.62L706.41,535.64l-24.49,27.84V704h-55V320h55V506a167,167,0,0,1,9.12-22.2q6.38-13.26,15.86-31.38L775.62,320h59.22l-90.2,170.46Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1024,704H870.08V320H1024v49.9h-99v109h92.7v50.16h-92.7v124h99Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.72,771.58q28.47,0,47.24,7.83t28,23.51q9.25,15.68,9.25,39.51A91.77,91.77,0,0,1,135,871.3a59.69,59.69,0,0,1-13.22,22.4,76,76,0,0,1-22.83,16.18L154,1020.59H109.07L62.49,919.25H40.67v101.34H0v-249Zm-.18,32.53H40.67v84.82H57.13q19.59,0,30-11.07t10.44-33.55q0-21-10.54-30.58T54.54,804.11Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.9,1020.59H183v-249H296.9v32.36H223.69v70.68h68.59v32.54H223.69v80.39H296.9Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453.49,1020.59l-17.19-70H374.18l-17.38,70H313.36l65.44-249h51.39l66.56,249ZM429.64,917.38l-17.75-75.29q-1.49-7.15-2.77-14.05c-.86-4.6-1.64-9.08-2.31-13.46s-1.39-8.48-2.13-12.34q-.56,5.61-1.57,12.09t-2.4,13.37q-1.4,6.9-2.87,13.88l-17.38,75.8Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M522.63,1020.59v-249H563.3v216h73.77v33Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M669.05,1020.59v-249h40.67v249Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M876.29,1020.59H744.66V992.83l85.6-188.55H746.32v-32.7H873.88v27.76L788.1,987.55h88.19Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1024,1020.59H910.12v-249H1024v32.36H950.79v70.68h68.59v32.54H950.79v80.39H1024Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhrase);
export default __webpack_public_path__ + "static/media/phrase.8d471cc0fdec34f9d1de99bf0f37f9cf.svg";
export { ForwardRef as ReactComponent };